<template>
  <div class="selector-numerico-wrapper" :class="wrapperClasses">
    <label v-if="label" for="">{{ label }}</label>

    <div :class="`input-group input-group-${size}`">
      <span class="input-group-btn">
        <button
          type="button"
          class="btn btn-default menos"
          :disabled="disabled"
          @click="incrementarValor(-1)"
        >
          <span class="fa fa-minus"></span>
        </button>
      </span>
      <InputNumerico
        :id="inputId"
        ref="input"
        v-model="valorInterno"
        configuracion="entero"
        :class="inputClasses"
        :name="name"
        :disabled="disabled"
        :min="min"
        :max="max"
        @update:model-value="cambiaValor"
        @focus="seleccionarValor"
        @blur="asegurarValor"
      />
      <span class="input-group-btn">
        <button
          type="button"
          class="btn btn-default mas"
          :disabled="disabled"
          @click="incrementarValor(1)"
        >
          <span class="fa fa-plus"></span>
        </button>
        <button
          v-if="puedeBorrar"
          type="button"
          class="btn borrar"
          :disabled="disabled"
          @click="borrarValor()"
        >
          <span class="fa fa-eraser"></span>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import InputNumerico from './InputNumerico.vue';
import { isBlank } from '../../libs/strings';

export default {
  components: { InputNumerico },
  props: {
    label: { type: String, default: null },
    name: { type: String, default: '' },
    size: { type: String, default: 'md' },
    modelValue: { type: [String, Number], default: null },
    disabled: { type: Boolean, default: false },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 99 },
    inputId: { type: String, default: undefined },
    inputClass: { type: String, default: '' },
    puedeBorrar: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      valorInterno: isBlank(this.modelValue) ? null : parseInt(this.modelValue.toString(), 10),
    };
  },
  computed: {
    inputClasses() {
      return `text-center form-control input-${this.size} ${this.inputClass}`;
    },
    wrapperClasses() {
      let clases = '';
      if (this.max > 999) {
        clases = 'wrapper-4-digitos';
      } else if (this.max > 99) {
        clases = 'wrapper-3-digitos';
      } else {
        clases = 'wrapper-2-digitos';
      }
      if (this.puedeBorrar) {
        clases += '-wide';
      }
      return `wrapper-${this.size} ${clases}`;
    },
  },
  watch: {
    modelValue() {
      this.valorInterno = this.modelValue ? parseInt(this.modelValue, 10) : null;
    },
  },
  methods: {
    seleccionarValor() {
      this.$refs.input.select();
    },
    asegurarValor() {
      // Provoca que se controle el mínimo y máximo
      this.asignarValor(this.valorInterno);
    },
    asignarValor(valorOriginal) {
      let valor = Number.isNaN(valorOriginal) ? 0 : valorOriginal;
      if (this.max !== undefined) {
        valor = Math.min(valor, this.max);
      }
      if (this.min !== undefined) {
        valor = Math.max(valor, this.min);
      }
      this.valorInterno = valor;
      this.$emit('update:modelValue', this.valorInterno);
    },
    incrementarValor(incremento) {
      this.asignarValor(this.valorInterno + incremento);
    },
    cambiaValor() {
      this.asegurarValor();
    },
    borrarValor() {
      this.$refs.input.asignarValorAutonumeric(null);
      this.valorInterno = null;
    },
  },
};

</script>

<style scoped>
  .wrapper-3-digitos,
  .wrapper-2-digitos {
    width: 130px;
  }
  .wrapper-3-digitos-wide,
  .wrapper-2-digitos-wide{
    width: 160px;
  }
  .wrapper-4-digitos{
    width: 150px;
  }
  .wrapper-4-digitos-wide{
    width: 180px;
  }
  .wrapper-sm.wrapper-2-digitos {
    width: 100px;
  }
  .wrapper-sm.wrapper-3-digitos {
    width: 110px;
  }
</style>
